import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { EditOutlined, TeamOutlined, UserAddOutlined, } from '@ant-design/icons';
import clsx from 'clsx';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const renderAssignSpeakerLabel = (mode) => {
    let label;
    let Icon;
    switch (mode) {
        case 'create':
            label = txt('createSpeaker');
            Icon = UserAddOutlined;
            break;
        case 'edit':
            label = txt('editSpeaker');
            Icon = EditOutlined;
            break;
        case 'select':
        default:
            label = txt('assignSpeaker');
            Icon = UserAddOutlined;
            break;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Icon, {}), ' ', label] }));
};
const SpeakerDialogHeader = ({ isSpeakerInDb, replacedSpeaker, mode, }) => {
    const nameRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    useEffect(() => {
        const element = nameRef.current;
        if (element) {
            setIsTruncated(element.scrollHeight > element.clientHeight);
        }
    }, [replacedSpeaker]);
    return (_jsx("div", { className: clsx(styles.header, {
            [styles.headerAssignSpeaker]: !replacedSpeaker,
        }), children: _jsxs("div", { className: styles.speakerName, children: [_jsx(Tooltip, { title: isTruncated ? replacedSpeaker === null || replacedSpeaker === void 0 ? void 0 : replacedSpeaker.composeLabel() : undefined, placement: "right", overlayStyle: { maxWidth: 300 }, children: _jsx("div", { ref: nameRef, className: styles.nameText, children: replacedSpeaker
                            ? replacedSpeaker.composeLabel()
                            : renderAssignSpeakerLabel(mode) }) }), isSpeakerInDb && (_jsx(Tooltip, { title: txt('speakerInDatabase'), children: _jsx(TeamOutlined, {}) }))] }) }));
};
export default SpeakerDialogHeader;
